<template>
	<div class="dropdown-list" v-click-outside="close" v-bind:class="{
		show: show,
	}">
		<div class="list">
			<slot />
		</div>
		<div class="dropdown-content" v-if="hasContent">
			<slot name="content" />
		</div>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  data: () => ({
    show: false,
    toggling: false
  }),
  props: {
    onRight: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    hasContent () {
      if (this.$slots.content) {
        return true
      }

      return false
    }
  },
  methods: {
    close () {
      if (!this.toggling) {
        this.show = false
      }
    },
    open () {
      this.show = true
    },
    toggle () {
      this.toggling = true

      setTimeout(() => {
        this.show = !this.show
        this.toggling = false
      }, 10)
    }
  }
}
</script>
